import {
	DEFAULT_TEMPLATES,
	TEMPLATE_DETAILS,
	TEMPLATES_FOR_TEAM_TYPE,
	type TemplateDetails,
	type TeamType,
} from './templateDetails';

export const getTemplatesForTeamType = (
	teamType?: TeamType,
): [TemplateDetails, TemplateDetails, TemplateDetails] => {
	const names = teamType ? TEMPLATES_FOR_TEAM_TYPE[teamType] : DEFAULT_TEMPLATES;
	return [TEMPLATE_DETAILS[names[0]], TEMPLATE_DETAILS[names[1]], TEMPLATE_DETAILS[names[2]]];
};
